import MenuButton from '@apps-common/ui-components/NavBar/NavMenuButton.jsx';
import ThemeModeIcon from '@mui/icons-material/DarkMode';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  useColorScheme,
} from '@mui/material';
import React from 'react';
import {trackEvent} from '@app/analytics';
import {THEME_MODE} from '@app/styles';

const ThemeMenu = () => {
  const {mode, setMode} = useColorScheme();

  const handleThemeModeChange = e => {
    const newTheme = e.target.value;
    setMode(newTheme);
    trackEvent('Theme mode', {
      action: 'Updated',
      theme: newTheme,
    });
  };

  return (
    <>
      <MenuButton
        title="Mode"
        label={<ThemeModeIcon fontSize="small" />}
        aria-label="theme-mode"
      >
        <Box
          sx={{
            mx: 2,
            my: 1,
          }}
        >
          <FormControl>
            <FormLabel>Appearance</FormLabel>
            <RadioGroup
              aria-labelledby="select-theme-mode"
              name="select-theme-mode"
              value={mode}
              onChange={e => handleThemeModeChange(e)}
            >
              <FormControlLabel
                value={THEME_MODE.SYSTEM}
                control={<Radio />}
                label="System OS (Default)"
              />
              <FormControlLabel
                value={THEME_MODE.LIGHT}
                control={<Radio />}
                label="Light"
              />
              <FormControlLabel
                value={THEME_MODE.DARK}
                control={<Radio />}
                label="Dark"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </MenuButton>
    </>
  );
};

export default ThemeMenu;
